import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import { navigation } from '../data/constant';

class TopNavigation extends Component {
  currentUserPayload = null;

  constructor(props) {
    super(props);
    this.state = {
      navItems: [],
    };
  }

  componentDidMount() {
    this.syncNavFromPropsOrStorage();
    window.addEventListener('storage', this.handleStorageUpdate);
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.user !== this.props.user ||
      prevProps.location.pathname !== this.props.location.pathname
    ) {
      this.syncNavFromPropsOrStorage();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('storage', this.handleStorageUpdate);
  }

  handleStorageUpdate = (event) => {
    if (event.key === 'user_params') {
      this.syncNavFromPropsOrStorage();
    }
  };

  syncNavFromPropsOrStorage = () => {
    const { user } = this.props;
    const payload = user || window.localStorage.getItem('user_params');

    if (!payload) {
      this.currentUserPayload = null;
      this.setState({ navItems: [] });
      return;
    }

    this.getNav(payload);
  };

  getNav = (payload) => {
    const userPayload = typeof payload === 'string' ? payload : JSON.stringify(payload);
    if (userPayload === this.currentUserPayload) return;

    let user = null;
    try {
      user = typeof payload === 'string' ? JSON.parse(payload) : payload;
    } catch (e) {
      this.currentUserPayload = null;
      this.setState({ navItems: [] });
      return;
    }

    if (!user?.roles?.length) {
      this.currentUserPayload = userPayload;
      this.setState({ navItems: [] });
      return;
    }

    const { tabs } = user.roles[0];
    const navItems = navigation.filter((nav) => {
      if (tabs.find((tab) => tab.url.split('cc.krgsc.kz')[1] === nav.link)) return true;
      else return false;
    });
    this.currentUserPayload = userPayload;
    this.setState({ navItems });
  };

  renderNav = (nav) => {
    const route = this.props.location.pathname;
    return (
      <ul>
        {nav.map((el, index) => (
          <li key={index} className={el.link === route ? 'active' : ''}>
            <Link to={el.link}>
              <img src={el.icon + '.png'} alt="navigation" className="dark" />
              <img src={el.icon + ',1.png'} alt="navigation" className="white" />
              <h3>{el.title}</h3>
            </Link>
          </li>
        ))}
      </ul>
    );
  };

  render() {
    const { navItems } = this.state;
    return (
      <nav>
        {this.renderNav(navItems.slice(0, 4))}
        {this.renderNav(navItems.slice(4, 8))}
        {this.renderNav(navItems.slice(8, 12))}
        {this.renderNav(navItems.slice(12, navItems.length))}
      </nav>
    );
  }
}

export default TopNavigation;
